module.exports = __webpack_public_path__ + "images/2d0ed7b0583d1fbe73a55d52722e68b4-server-item.svg";